(() => {
  'use strict';
  if (window.__CANFOTO_E1_F10_R14D_FIX4_GLOBAL_SCROLL_ACTIONS__) return;
  window.__CANFOTO_E1_F10_R14D_FIX4_GLOBAL_SCROLL_ACTIONS__ = true;

  const OWNER = 'CANFOTO-E1-F10-R14B-GLOBAL-SCROLL-ACTIONS-FOOTER-200-R1';
  const VERSION = 'CANFOTO-E1-F10-R14D-FIX4-GLOBAL-NORA-ADMISSION-R1';
  const GATE_PX = 200;
  const NORA_HREF = '/pages/led-isik-secim-motoru';
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => [...r.querySelectorAll(s)];

  function pageType(){
    const b=document.body;
    if(!b) return 'unknown';
    if(b.classList.contains('template-index')) return 'home';
    if(b.classList.contains('template-collection')) return 'collection';
    if(b.classList.contains('template-product')) return 'product';
    return 'other';
  }
  function admitted(type=pageType()){
    return type==='home'||type==='collection'||type==='product';
  }
  function removeGlobal(){
    qa('[data-cf-global-scroll-actions]').forEach(el=>el.remove());
  }
  function removeLegacyHomeActions(){
    if(pageType()!=='home') return 0;
    const nodes=qa('.mobile-sticky.cf42-nora-sticky, .cf42-backtop.cf43-hover-calibrated, .cf42-backtop');
    nodes.forEach(el=>el.remove());
    return nodes.length;
  }
  function publishState(extra={}){
    const type=pageType(),allow=admitted(type),nora=q('[data-cf-global-scroll-nora]'),back=q('[data-cf-global-scroll-backtop]');
    const state={
      owner:OWNER,version:VERSION,gatePx:GATE_PX,pageType:type,admitted:allow,
      noraHref:nora?.getAttribute('href')||'',globalCount:qa('[data-cf-global-scroll-actions]').length,
      noraCount:qa('[data-cf-global-scroll-nora]').length,backtopCount:qa('[data-cf-global-scroll-backtop]').length,
      legacyHomeNoraCount:qa('.mobile-sticky.cf42-nora-sticky').length,
      legacyHomeBacktopCount:qa('.cf42-backtop').length,
      ...extra
    };
    window.CANFOTO_E1_F10_R14B_GLOBAL_SCROLL_ACTIONS_STATE=state;
    document.documentElement.dataset.cfGlobalNoraAdmission=allow?'ALLOWED':'DENIED';
    document.documentElement.dataset.cfGlobalNoraPage=type;
    return state;
  }

  function create(){
    if(q('[data-cf-global-scroll-actions]')) return q('[data-cf-global-scroll-actions]');
    const wrap=document.createElement('div');
    wrap.dataset.cfGlobalScrollActions=OWNER;
    wrap.dataset.cfGlobalScrollVersion=VERSION;
    wrap.innerHTML =
      `<a class="cf-global-scroll-nora" data-cf-global-scroll-nora aria-hidden="true" tabindex="-1" href="${NORA_HREF}" aria-label="NORA · Bana Uygun Işığı Bul">`+
        `<span class="cf-global-scroll-nora__badge">NORA</span>`+
        `<span class="cf-global-scroll-nora__copy">BANA UYGUN IŞIĞI BUL</span>`+
        `<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"></path></svg>`+
      `</a>`+
      `<button class="cf-global-scroll-backtop" data-cf-global-scroll-backtop aria-hidden="true" tabindex="-1" type="button" aria-label="Başa Dön">`+
        `<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M12 19V5M6 11l6-6 6 6"></path></svg>`+
        `<span>BAŞA DÖN</span>`+
      `</button>`;
    document.body.appendChild(wrap);
    return wrap;
  }

  function boot(){
    const type=pageType();
    if(!admitted(type)){
      removeGlobal();
      publishState({visible:false,footerDistancePx:null,footerTop:null,viewport:window.innerHeight||0});
      return;
    }

    const footer=q('footer.footer-group[is="footer-group"], footer.footer-group, footer');
    if(!footer){
      removeGlobal();
      publishState({visible:false,footerDistancePx:null,footerTop:null,viewport:window.innerHeight||0,reason:'FOOTER_MISSING'});
      return;
    }

    create();
    if(type==='home') removeLegacyHomeActions();

    const nora=q('[data-cf-global-scroll-nora]');
    const back=q('[data-cf-global-scroll-backtop]');
    if(!nora || !back){publishState({visible:false,reason:'CONTROL_MISSING'});return;}

    let ticking=false;
    function gateState(){
      const rect=footer.getBoundingClientRect();
      const viewport=window.visualViewport?.height || window.innerHeight || document.documentElement.clientHeight;
      const distance=Math.round(rect.top-viewport);
      const visible=distance<=GATE_PX;
      return {visible,distance,footerTop:rect.top,viewport};
    }
    function setVisible(el,on){
      el.classList.toggle('is-visible',!!on);
      el.setAttribute('aria-hidden',on?'false':'true');
      el.tabIndex=on?0:-1;
    }
    function apply(){
      ticking=false;
      if(type==='home') removeLegacyHomeActions();
      const s=gateState();
      setVisible(nora,s.visible);setVisible(back,s.visible);
      document.documentElement.dataset.cfGlobalScrollGate=s.visible?'VISIBLE':'HIDDEN';
      publishState({visible:s.visible,footerDistancePx:s.distance,footerTop:s.footerTop,viewport:s.viewport});
    }
    function schedule(){if(ticking)return;ticking=true;requestAnimationFrame(apply);}

    back.addEventListener('click',()=>{
      const reduced=window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({top:0,left:0,behavior:reduced?'auto':'smooth'});
    });

    apply();
    addEventListener('scroll',schedule,{passive:true});
    addEventListener('resize',schedule,{passive:true});
    window.visualViewport?.addEventListener('resize',schedule,{passive:true});
    if('ResizeObserver' in window) new ResizeObserver(schedule).observe(document.documentElement);

    window.debugCanfotoGlobalScrollActionsV2=()=>{
      apply();
      const state=window.CANFOTO_E1_F10_R14B_GLOBAL_SCROLL_ACTIONS_STATE;
      const allow=admitted(pageType());
      const out={
        ok:!!state && state.owner===OWNER && state.version===VERSION && state.gatePx===200 &&
          state.admitted===allow && state.globalCount===(allow?1:0) && state.noraCount===(allow?1:0) &&
          (!allow || state.noraHref===NORA_HREF) && (pageType()!=='home' || (state.legacyHomeNoraCount===0&&state.legacyHomeBacktopCount===0)),
        version:'CANFOTO-E1-F10-R14D-FIX4-GLOBAL-SCROLL-ACTIONS-QA-V2',state
      };
      console.log('=== CANFOTO E1-F10 R14D FIX4 GLOBAL SCROLL ACTIONS QA V2 ===');
      console.log(out);return out;
    };
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
